// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundles/" + (chunkId === 28 ? "product-list-map" : chunkId) + "." + {"28":"dfae2744b656a3332e03","349":"ed7bf8a8b21c16f7c2dd","588":"f4c8dcbbb1a5d06d4141"}[chunkId] + ".chunk.js";
};